import React from "react";
import { TextLabel, FeedBackPage } from "../../../../shared/components";
import { Grid } from "@material-ui/core";
import { useTranslations } from "adapters/i18n";

const FormulacaoSemItems = () => {
  const { t } = useTranslations();
  return (
    <Grid
      container
      direction="column"
      justify="center"
      style={{
        minHeight: "60vh",
      }}
    >
      <FeedBackPage>
        <Grid container direction="column" alignItems="center">
          <img
            src="../images/fechamentoTelaVazia.png"
            alt="Lupa de tela vazia"
          />
          <TextLabel
            id="labelFormulacaoFeedBack"
            block
            color="default2"
            customStyle={{ paddingTop: 10 }}
          >
            {t("formulation:list.no-formulation")}
          </TextLabel>
        </Grid>
      </FeedBackPage>
    </Grid>
  );
};

export default FormulacaoSemItems;
